import React, { Component } from 'react';
import { Grid, Row, Col, Form, FormGroup, FormControl, ControlLabel, ButtonToolbar, Button } from 'react-bootstrap'

import { UploadCommand } from './commands/UploadCommand';
import { LoadingSpinner } from '../LoadingSpinner';
import { HandleMessage } from '../HandleMessage';

export class ImportLayoutConfigurationForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                file: undefined,
            },
            styles: {
                file: null
            },
            actions: {
                isUploading: false
            },
            message: {
                message: <LoadingSpinner />,
                style: "primary",
                icon: "transfer",
                title: "A Carregar o Layout..."
            },
            commands: {
                uploadCommand: new UploadCommand(props.appName)
            }
        };
    }

    // -----------------------

    uploadSuccessCallback(message) {
        const { actions } = this.state;

        actions.isUploading = false;

        this.setState({
            actions: actions
        });

        this.props.exit(true, message);
    }

    operationErrorCallback(message) {
        const { actions } = this.state;

        actions.isUploading = false;

        this.setState({
            actions: actions
        });

        this.props.exit(false, message);
    }

    // -----------------------

    onChangeFile(event, target) {
        const { form } = this.state;

        const uploadedFile = event.target.files[0];

        if (undefined !== uploadedFile) {
            form[target] = uploadedFile;

            this.setState({
                form: form
            });
        }
    }

    onUpload() {
        const { form, actions, commands } = this.state;

        const styles = {
            file: null
        };

        if (null === form.file || undefined === form.file) {
            styles.file = "error";
        }

        if (null === styles.file) {
            actions.isUploading  = true;
            
            commands.uploadCommand.uploadLayout(
                form,
                (a) => this.uploadSuccessCallback(a),
                (a) => this.operationErrorCallback(a)
            );

            form.file = null;
        }

        this.setState({
            form: form,
            styles: styles,
            actions: actions
        });
    }

    // -----------------------

    render() {
        const { actions, styles, message } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Form>
                            <FormGroup
                                controlId="formDataFile"
                                validationState={styles.file} >
                                <ControlLabel>Carregar Layout</ControlLabel>
                                <FormControl
                                    type="file"
                                    placeholder="Layout"
                                    onChange={(e) => this.onChangeFile(e, "file")} />
                            </FormGroup>
                        </Form>
                    </Row>
                    <Row>
                        <Col>
                            <ButtonToolbar>
                                <Button bsStyle="default" onClick={() => this.onUpload()}>CARREGAR</Button>
                                <Button bsStyle="default" onClick={() => this.props.exit(true)}>CANCELAR</Button>
                            </ButtonToolbar>
                        </Col>
                    </Row>
                </Grid>
                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={actions.isUploading}
                    small
                    noButtons />
            </div>
        );
    }
}
